import { useContext, useEffect, useState } from 'react';
import CommandCenterService from '../../../service/CommandCenterService';
import { showToastMessage } from '../../../utils/commonFunctions';
import { GenericSimulatorProviderContext } from '../context';
import useUrlParams from './useUrlParams';
import useDashboard from './useDashboard';
const useConsole = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { scenario , selected_element} = useDashboard();

    const context = useContext(GenericSimulatorProviderContext);
    if (context === undefined) {
        throw new Error('useConsole must be used within a GenericSimulatorStateProvider');
    }

    const [commandDetails, setCommandDetails] = useState<any | null>(null);
    const { consoleFilterOptions, setConsoleFilterOptions, highlightedCommands, setHighlightedCommands } = context;
    const { mission_id, scenario_id } = useUrlParams();
    const { trueTwinId, elementId } = selected_element || {};


    const addCommandUidToHighlight = (commandUid: string) => {
        setHighlightedCommands(prev => {
            const next = new Set(prev);
            next.add(commandUid);
            return next;
        });
        setTimeout(() => {
            setHighlightedCommands(prev => {
                const next = new Set(prev);
                next.delete(commandUid);
                return next;
            });
        }, 30000);
    };

    const removeCommandUidForHighlight = (commandUid: string) => {
        setHighlightedCommands(prev => {
            const next = new Set(prev);
            next.delete(commandUid);
            return next;
        });
    };

    const getFilterOptions = async (trueTwinIdParam: string, scenario_id_param: string, elementIdParam: string, mission_id_param: string) => {
        try {
            const res = await CommandCenterService.getCommandFilterOptionsForMda(trueTwinIdParam, scenario_id_param, elementIdParam, mission_id_param);
            if (res?.data?.data?.length) {
                setConsoleFilterOptions(res.data.data[0]);
            }
        } catch (err: any) {
            console.error('Failed to get filter options', err);
            showToastMessage('error', err?.response?.data?.message || 'Failed to get filter options');
        }
    };

    const getCommandDetails = async (commandId: any) => {
        if (!trueTwinId) return;
        setLoading(true);
        try {
            const res = await CommandCenterService.getCommandDetailsById(trueTwinId, elementId, scenario_id, commandId?.['CommandUid']);
            setCommandDetails(res);
        } catch (err) {
            console.error('Failed to get command details', err);
        } finally {
            setLoading(false);
        }
    };

    const exportMessages = async () => {
        if (!trueTwinId) return;
        const session_id = sessionStorage.getItem('sessionId') || '';
        const credentials = sessionStorage.getItem("authentication");

        try {
            const res = await CommandCenterService.exportConsoleMessages(
                elementId,
                trueTwinId,
                scenario_id,
                session_id,
                credentials
            );

            if (res && typeof res === 'string' && res.startsWith('http')) {
                window.location.href = res;
                showToastMessage('success', 'Messages exported successfully');
            }
        } catch (err) {
            console.error('Failed to export messages', err);
            showToastMessage('error', 'Failed to export messages');
        }
    };
    useEffect(() => {
        if (trueTwinId && scenario_id && elementId && mission_id) {
            getFilterOptions(trueTwinId, scenario_id, elementId, mission_id);
        }
    }, [trueTwinId, scenario_id, elementId, mission_id]);

    return {
        loading,
        error,
        getCommandDetails,
        commandDetails,
        exportMessages,
        consoleFilterOptions,
        getFilterOptions,
        highlightedCommands,
        setHighlightedCommands,
        addCommandUidToHighlight,
        removeCommandUidForHighlight
    };
};

export default useConsole;
